import "./ProgressRing.css";
import React from "react";
import {Progress} from "../util/ProgressManager";
import {useProgressValue} from "../hooks/useProgressValue";

export interface Props {
  progress: Progress;
  radius: number;
  strokeWidth: number;
}

export const ProgressRing = ({progress, radius, strokeWidth}: Props) => {

  const value = useProgressValue(progress);

  if (value !== progress.maxValue) {
    const partial = value / progress.maxValue;
    const percentage = Math.floor(100 * partial);
    const normalizedRadius = radius - (strokeWidth * 2);
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset1 = circumference - partial * circumference;
    const strokeDashoffset2 = -1 * (circumference - strokeDashoffset1);

    return <svg height={radius * 2} width={radius * 2}>
      <circle
          id="circle1"
          stroke="#ffffff"
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference + ' ' + circumference}
          strokeDashoffset={strokeDashoffset1}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          transform={"rotate(" + -90 + ", " + radius + ", " + radius + ")"}
      />
      <circle
          id="circle2"
          stroke="#555555"
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference + ' ' + circumference}
          strokeDashoffset={strokeDashoffset2}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          transform={"rotate(" + -90 + ", " + radius + ", " + radius + ")"}
      />
      <text x="50%" y="60%" textAnchor="middle" stroke="#ffffff" strokeWidth="1px" fontSize="9px">{percentage}</text>
    </svg>
  } else {
    return <svg height={radius * 2} width={radius * 2}/>
  }
}